export default __webpack_public_path__ + "static/media/page-three.47d5dd26.jpeg";